import React, { useState, useEffect } from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import { Search, X, RotateCcw } from 'lucide-react';
import { FiltrosProveedor } from '../types';

interface Props {
  filtros: FiltrosProveedor;
  onBuscar: (busqueda: string) => void;
  onLimpiar: () => void;
}

export function ProveedorFiltros({ filtros, onBuscar, onLimpiar }: Props) {
  const [inputValue, setInputValue] = useState(filtros.busqueda ?? '');

  useEffect(() => {
    const external = filtros.busqueda ?? '';
    if (external !== inputValue) setInputValue(external);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros.busqueda]);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'minmax(420px,1fr) auto' },
        gap: 1.5,
        alignItems: 'center',
        mb: 2,
      }}
    >
      <TextField
        placeholder="Buscar por razón social o NIT..."
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          onBuscar(e.target.value);
        }}
        data-testid="busqueda-input"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search size={20} color="#756D77" />
            </InputAdornment>
          ),
          endAdornment: inputValue.length > 0 ? (
            <InputAdornment position="end">
              <Box
                component="button"
                aria-label="Limpiar búsqueda"
                onClick={() => { setInputValue(''); onBuscar(''); }}
                sx={{ border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', p: 0, color: '#756D77' }}
              >
                <X size={17} />
              </Box>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: 48,
            borderRadius: '8px',
            '& fieldset': { borderColor: '#DCD6DD' },
            '&:hover fieldset': { borderColor: '#DCD6DD' },
            '&.Mui-focused fieldset': { borderColor: '#A84F8D' },
          },
        }}
      />
      {inputValue.length > 0 && (
        <Box
          component="button"
          aria-label="Limpiar filtros"
          onClick={() => { setInputValue(''); onLimpiar(); }}
          data-testid="limpiar-filtros"
          sx={{
            height: 48, px: 2, borderRadius: '8px', border: '1px solid #D9AACA', background: 'transparent',
            color: '#9E427F', display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer',
            fontSize: 14, fontWeight: 500, whiteSpace: 'nowrap',
            transition: 'background 150ms', '&:hover': { background: '#FDF4FB' },
          }}
        >
          <RotateCcw size={18} />
          Limpiar
        </Box>
      )}
    </Box>
  );
}
